<template>
    <div v-show="paketInfo" class="mt-1 mb-1 float-right paket-container">
        <div class="box">
            <div class="row">
                <div class="col-12 col-sm-9 col-md-9 col-lg-9">
                    <span class="fs-9 bold">Paket Anda: </span> <span class="fs-8 bold" v-bind:class="blueOrRed" >{{ exist == 0 ? '' : exist == 1 ? name : 'Tidak ada paket aktif' }} </span>
                    <br />
                    <span class="fs-8">Visit Pasien</span> <span class="blue bold fs-9">{{ sisa_paket || '-' }}</span>
                    <span class="fs-8"><span class="line-color"> |</span> Add On Whatsapp </span> <span
                        class="blue bold fs-9">{{ sisa_wa }}</span>
                    <span class="fs-8"><span class="line-color"> |</span> Add On SMS</span> <span
                        class="blue bold fs-9">{{ sisa_sms }}</span> <router-link :to="{ name: 'subskripsi-klinik' }" class="fs-8 txt-lebih-lanjut d-sm-none btn btn-xs btn-lebih-lanjut white">
                        Lebih lanjut
                    </router-link>
                </div>
                <div class="d-none d-sm-block d-md-block col-sm-3 col-md-3 col-lg-3 text-right align-self-center">
                    <router-link :to="{ name: 'subskripsi-klinik' }" class="btn btn-lebih-lanjut">
                        Lebih Lanjut
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Paket',
    computed: {
        ...mapGetters({
            getKlinik: "getKlinik",
            getRolesName: "getRolesName"
        }),
        blueOrRed() {
            return this.exist != 0 && this.exist == 1 ? 'blue' : 'red';
        }
    },
    data() {
        return {
            paketInfo: false,
            exist: 0,
            name: null,
            sisa_paket: null,
            sisa_wa: null,
            sisa_sms: null
        }
    },
    mounted () {
        this.$root.$on('updatePaket', (data) => {
            this.updatePaket(data)
            this.showPaketInfo()
        })
        this.cekPaketNolock();
        this.showPaketInfo();
    },
    methods: {
        updatePaket(data) {
            this.exist = data.exist ? 1 : 2
            this.name = data.name
            this.sisa_paket = data.sisa_paket
            this.sisa_wa = data.sisa_wa
            this.sisa_sms = data.sisa_sms
        },
        showPaketInfo() {
            this.paketInfo = this.isPic()
        },
        isPic() {
          return /pic/.test(this.getRolesName);
        },
    }
}
</script>

<style>
.fs-9 {
    font-size: 10pt;
}

.fs-8 {
    font-size: 9pt;
}

.fs-7 {
    font-size: 8pt;
}

.bold {
    font-weight: bold;
}

.blue {
    color: #1484C9 !important;
}

.red {
    color: #FF0000 !important;
}

.white {
    color: #fff !important;
}

.line-color {
    color: #CACACA !important;
}

.btn-lebih-lanjut {
    background-color: #337B8D !important;
    color: #fff;
    font-size: 7pt;
    /* margin-top: 3px; */
}

.btn-lebih-lanjut:hover {
    color: #fff;
}

.box {
    border: 1px solid #ddd;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 10px;
    padding-right: 10px;
    margin: 10px;
    border-radius: 5px;
}

.w-60 {
    width: 60% !important;
}

.paket-container {
    line-height: 1;
}

.txt-lebih-lanjut {
    color: #337B8D;
}

.btn-xs {
  padding: .25rem .4rem;
  font-size: 7pt;
  line-height: .5;
  border-radius: .2rem;
}

@media (min-width: 576px) {
    .paket-container {
        width: 100%;
    }
}

@media (min-width: 768px) {
    .paket-container {
        width: 100%;
    }
}

@media (min-width: 992px) {
    .paket-container {
        width: 75%;
    }
}

@media (min-width: 1200px) {
    .paket-container {
        width: 50%;
    }
}

</style>